import { SideBar, SideBarProps } from 'apps/frontend/types/Types';
import { FC } from 'react';
import SideBanner from './SideBanner/SideBanner';
import SideList from './SideList/SideList';

const SideBar: FC<SideBarProps> = ({ sideBarSequence }) => {
  sideBarSequence.sort((a, b) => {
    return a.position < b.position ? -1 : a.position > b.position ? 1 : 0;
  });

  return (
    <>
      {sideBarSequence.map((sequence: SideBar, index) => {
        return (
          <span key={index}>
            {
              sequence.componentType === 'numbered' && (
                <SideList
                  key={'numbered'}
                  type={'numbered'}
                  title={sequence.title}
                ></SideList>
              )
            }
            {
              sequence.componentType === 'SmallBanner' && (
                <div className="sticky-banner">
                  <SideBanner key={'Small'} size={'Small'}></SideBanner>
                </div>
              )
            }
            {
              sequence.componentType === 'simple' && (
                <SideList
                  key={'simple'}
                  type={'simple'}
                  title={sequence.title}
                ></SideList>
              )
            }
            {
              sequence.componentType === 'dotList' && (
                <SideList
                  key={'dotList'}
                  type={'dotList'}
                  title={sequence.title}
                ></SideList>
              )
            }
            {
              sequence.componentType === 'LargeBanner' && (
                <div className="sticky-banner">
                  <div className='hide_div_mobile'>
                  <SideBanner key={'Large'} size={'Large'}></SideBanner>
                  </div>
                  <div className='hide_div_web'>
                  <SideBanner key={'small'} size={'Small'}></SideBanner>
                  </div>
                </div>
              )
            }
          </span>

        );
      })}
    </>
  );
};

export default SideBar;
